import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=9f35aac0"
import script from "./ReadMore.vue?vue&type=script&lang=ts"
export * from "./ReadMore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports